import moment from "moment";
import React from "react";
import { FormProvider } from "react-hook-form";
import { Stack, Box } from "@mui/material";
import { RFHTextField as RHFTextField, RHFRadioGroup } from '../RFH'
import { CustomButton } from "../Button/Button";
import { useWorklogMissingForm } from "./hooks/useWorklogMissingForm";

function WorklogMissingForm({ date, time, handleClose, dayName }) {
  const { isPending, leaveTypeOptions, methods, onSubmit } =
    useWorklogMissingForm({
      date,
      handleClose,
    });

  return (
    <div>
      <div className="missing-worklog-list-containor">
        <div className="d-flex justify-content-space-between">
          <p className="note">Worklog missing</p>
          <p className="date-hour">{`${dayName} ${moment(date).format(
            "MMM DD, YYYY"
          )} (${time?.toFixed(2)} hrs)`}</p>
        </div>
        <FormProvider {...methods}>
          <div>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <div>
                <Stack spacing={2}>
                  <RHFRadioGroup
                    name={"leave_type"}
                    options={leaveTypeOptions}
                    className={"worklog-missing-reason-options"}
                    row={3}
                    isCircularRadio={true}
                  />
                  <RHFTextField
                    name="reason"
                    placeholder={"Enter Reason (Optional).."}
                    defaultPadding={true}
                    className="worklog-missing-reason-input"
                    multiline
                    rows={2}
                  />
                </Stack>
              </div>

              <Box className="form-actions">
                <CustomButton
                  type="submit"
                  sx={{ padding: "8px 32px" }}
                  className="theme-bg-color mr-2"
                  disabled={isPending}
                >
                  Submit
                </CustomButton>
                <CustomButton onClick={handleClose} disabled={isPending}>
                  Cancel
                </CustomButton>
              </Box>
            </form>
          </div>
        </FormProvider>
      </div>
    </div>
  );
}

export default WorklogMissingForm;
